module.exports = __webpack_public_path__ + "img/be5bef9.png";